function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import fp from 'lodash/fp';
import T from 'prop-types';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown, Table } from 'react-bootstrap';
import classNames from 'classnames';
import { format } from 'date-fns';
import { USER_TYPE } from '../../../constants/user';
import UserAvatar from '../../../pages/profile/UserAvatar';
import { hideModal, showModal } from '../../../redux/actions';
import text from '../../../text';
import { getProjectLatestJob } from '../../../utilities/project';
import { canGiveTrial, getUserType, isStaff } from '../../../utilities/user';
import MeatballDropdown from '../../dropdown/MeatballDropdown';
import { GIVE_USER_TRIAL_MODAL } from '../../modal/GiveUserTrialModal';
var _obj;
var USER_TYPE_LABEL = (_obj = {}, _define_property(_obj, USER_TYPE.FREE, text('free')), _define_property(_obj, USER_TYPE.TRIAL, text('trial')), _define_property(_obj, USER_TYPE.ESSENTIALS, text('essentials')), _define_property(_obj, USER_TYPE.LARKI_SUPPORT, text('larkiSupport')), _define_property(_obj, USER_TYPE.GOVERNMENT, text('governmentFullWord')), _obj);
var formatDate = function(date) {
    return date ? format(new Date(date), 'd MMM yyyy') : null;
};
var InvitationTable = function(param) {
    var invitations = param.invitations, project = param.project, resendInvitation = param.resendInvitation, removeProjectUser = param.removeProjectUser, updateUserProjectVisibility = param.updateUserProjectVisibility;
    var dispatch = useDispatch();
    var currentUser = useSelector(function(state) {
        return state.profileReducer.userProfile;
    });
    var job = getProjectLatestJob(project);
    var showInvite = function(invite) {
        return isStaff(currentUser.role) || !isStaff(invite.user.role);
    };
    var isCurrentUser = function(invite) {
        return invite.user.id === currentUser.id;
    };
    var showVisibilityMenu = function(invite) {
        return isStaff(currentUser.role) && !isStaff(invite.user.role);
    };
    var showHiddenIndicator = function(invite) {
        return isStaff(currentUser.role) && invite.visibility === 'staff' || isStaff(invite.user.role);
    };
    var latestStatusUpdatedAt = function(invite) {
        var _invite_user;
        if (invite === null || invite === void 0 ? void 0 : invite.updated_at) return formatDate(invite.updated_at);
        if (invite === null || invite === void 0 ? void 0 : (_invite_user = invite.user) === null || _invite_user === void 0 ? void 0 : _invite_user.updated_at) return formatDate(invite.user.updated_at);
        return null;
    };
    var handleGiveTrial = function(user) {
        dispatch(showModal(GIVE_USER_TRIAL_MODAL, {
            user: user,
            onHide: function() {
                return dispatch(hideModal(GIVE_USER_TRIAL_MODAL));
            }
        }));
    };
    var groupedInvitations = fp.flow(fp.map(function(invite) {
        return _object_spread_props(_object_spread({}, invite), {
            user_type: getUserType(invite.user)
        });
    }), fp.groupBy('user_type'), fp.mapValues(function(invites) {
        return invites.filter(showInvite);
    }), fp.pickBy(function(invites) {
        return !fp.isEmpty(invites);
    }))(invitations);
    var renderInviteRow = function(invite) {
        return /*#__PURE__*/ React.createElement("tr", {
            key: invite.user.id
        }, /*#__PURE__*/ React.createElement("td", {
            className: "UserNameCell d-flex flex-row"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "d-flex flex-row"
        }, /*#__PURE__*/ React.createElement(UserAvatar, {
            profileImage: invite.user.profile_image,
            className: "mr-3"
        }), /*#__PURE__*/ React.createElement("div", {
            className: "d-flex flex-column justify-content-center name-wrapper"
        }, /*#__PURE__*/ React.createElement("p", {
            className: "m-0 name font-14 font-weight--600 text-break"
        }, invite.user.full_name), /*#__PURE__*/ React.createElement("p", {
            className: classNames('m-0 email font-12', {
                'text-truncate': invite.user.full_name,
                'text-break': !invite.user.full_name
            })
        }, invite.user.email)))), /*#__PURE__*/ React.createElement("td", {
            className: "StatusCell font-italic font-weight--400"
        }, /*#__PURE__*/ React.createElement("p", {
            className: "m-0"
        }, fp.capitalize(invite === null || invite === void 0 ? void 0 : invite.invite_status)), /*#__PURE__*/ React.createElement("p", {
            className: "m-0"
        }, latestStatusUpdatedAt(invite))), /*#__PURE__*/ React.createElement("td", {
            className: "MembershipCell px-0"
        }, /*#__PURE__*/ React.createElement("p", {
            className: "m-0 font-weight--600 font-14"
        }, USER_TYPE_LABEL[getUserType(invite.user)], showHiddenIndicator(invite) && " (".concat(text('Hidden'), ")"))), /*#__PURE__*/ React.createElement("td", {
            className: "ActionCell"
        }, /*#__PURE__*/ React.createElement(MeatballDropdown, null, /*#__PURE__*/ React.createElement(Dropdown.Item, {
            disabled: (invite === null || invite === void 0 ? void 0 : invite.invite_status) !== 'pending',
            onClick: function() {
                var _invite_user;
                return resendInvitation(invite === null || invite === void 0 ? void 0 : (_invite_user = invite.user) === null || _invite_user === void 0 ? void 0 : _invite_user.email);
            }
        }, text('resendInvitation')), canGiveTrial(currentUser, invite.user) && /*#__PURE__*/ React.createElement(Dropdown.Item, {
            onClick: function() {
                return handleGiveTrial(invite.user);
            }
        }, text('addTrial')), /*#__PURE__*/ React.createElement(Dropdown.Item, {
            disabled: (job === null || job === void 0 ? void 0 : job.owner_user_id) === invite.user.id,
            onClick: function() {
                return removeProjectUser(project, invite);
            }
        }, isCurrentUser(invite) ? text('leaveProject') : text('removeProjectUser')), showVisibilityMenu(invite) && /*#__PURE__*/ React.createElement(Dropdown.Item, {
            onClick: function() {
                return updateUserProjectVisibility(invite);
            }
        }, invite.visibility === 'public' ? text('Hide') : text('Show')))));
    };
    return /*#__PURE__*/ React.createElement(Table, {
        className: "Table InvitationTable",
        responsive: true
    }, /*#__PURE__*/ React.createElement("thead", null, /*#__PURE__*/ React.createElement("tr", null, /*#__PURE__*/ React.createElement("th", null, text('projectUsers')), /*#__PURE__*/ React.createElement("th", null, text('status')), /*#__PURE__*/ React.createElement("th", {
        className: "px-0"
    }, text('member')), /*#__PURE__*/ React.createElement("th", {
        className: "ActionCell"
    }, text('actions')))), /*#__PURE__*/ React.createElement("tbody", null, fp.flow(fp.map(function(invites) {
        return invites.map(renderInviteRow);
    }))(groupedInvitations)));
};
InvitationTable.propTypes = {
    invitations: T.arrayOf(T.shape({
        user: T.shape({
            id: T.string.isRequired,
            email: T.string.isRequired,
            full_name: T.string,
            profile_image: T.string,
            role: T.string,
            updated_at: T.string
        }).isRequired,
        invite_status: T.string,
        updated_at: T.string,
        visibility: T.string
    })).isRequired,
    project: T.object,
    resendInvitation: T.func.isRequired,
    removeProjectUser: T.func.isRequired,
    updateUserProjectVisibility: T.func.isRequired
};
export default InvitationTable;
